<template>
  <div>
    <div class="login">
      <div class="form-wrapper">
        <div class="login-header">
          A G R I
        </div>
        <div class="input-wrapper">
          <div class="border-wrapper">
            <input
              type="text"
              v-model="loginForm.username"
              placeholder="username"
              class="border-item"
              autocomplete="off"
            />
          </div>
          <div class="border-wrapper">
            <input
              type="password"
              v-model="loginForm.password"
              placeholder="password"
              class="border-item"
              autocomplete="off"
            />
          </div>
        </div>
        <div class="action">
          <div class="btn" @click="login">login</div>
        </div>
      </div>
    </div>
    <div
      style="position:fixed;text-align: center;bottom: 10px;margin:0 auto;width:100%;color:#5c6b77"
    >
      Copyright © 北京大象慢跑科技有限公司版权所有
      <a target="_blank" style="color:#5c6b77" href="https://beian.miit.gov.cn/"
        >京ICP备2023027790号-3</a
      >
    </div>
  </div>
</template>
<script>
import { login } from "../views/api/api.js";
import { setToken } from "../views/utils/authUtils";
export default {
  data() {
    return {
      loginForm: {
        username: "",
        password: ""
      }
    };
  },
  methods: {
    login() {
      login(this.loginForm).then(res => {
        if (res.code == 0) {
          this.$message({
            message: "登录成功",
            type: "success"
          });
          setToken(res.data.token);
          let redirect = this.$route.query.redirect;
          if (!redirect) {
            redirect = "/home";
          }
          this.$router.push(redirect);
        }
      });
    }
  }
};
</script>
<style scoped>
.login {
  height: 100%;
  width: 100%;
  font-family: JetBrains Mono Medium;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("../assets/image/login.png");
  background-size: 100% 100%;
  position: fixed;
}
.form-wrapper {
  width: 300px;
  background-color: rgba(41, 45, 62, 0.8);
  color: #fff;
  border-radius: 2px;
  padding: 50px;
}

.form-wrapper .login-header {
  text-align: center;
  font-size: 35px;
  text-transform: uppercase;
  line-height: 100px;
  height: 20%;
}

.form-wrapper .input-wrapper input {
  background-color: rgb(41, 45, 62);
  border: 0;
  width: 100%;
  text-align: center;
  font-size: 15px;
  color: #fff;
  outline: none;
}

.form-wrapper .input-wrapper input::placeholder {
  text-transform: uppercase;
}

.form-wrapper .input-wrapper .border-wrapper {
  background-image: linear-gradient(to right, #e8198b, #0eb4dd);
  width: 100%;
  height: 50px;
  margin-bottom: 20px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.form-wrapper .input-wrapper .border-wrapper .border-item {
  height: calc(100% - 4px);
  width: calc(100% - 4px);
  border-radius: 30px;
}

.form-wrapper .action {
  display: flex;
  justify-content: center;
}

.form-wrapper .action .btn {
  width: 60%;
  text-transform: uppercase;
  border: 2px solid #0e92b3;
  text-align: center;
  line-height: 50px;
  border-radius: 30px;
  cursor: pointer;
}

.form-wrapper .action .btn:hover {
  background-image: linear-gradient(120deg, #84fab0 0%, #8fd3f4 100%);
}

.form-wrapper .icon-wrapper {
  text-align: center;
  width: 60%;
  margin: 0 auto;
  margin-top: 20px;
  border-top: 1px dashed rgb(146, 146, 146);
  padding: 20px;
}

.form-wrapper .icon-wrapper i {
  font-size: 20px;
  color: rgb(187, 187, 187);
  cursor: pointer;
  border: 1px solid #fff;
  padding: 5px;
  border-radius: 20px;
}

.form-wrapper .icon-wrapper i:hover {
  background-color: #0e92b3;
}
</style>



// WEBPACK FOOTER //
// src/components/DhLogin.vue